import { Right, SimpleBlock } from 'ui-builder';
import styles from './WebhookRequestLogInfo.module.scss';
import { CopyValueToClipboard } from 'features/nekst-widgets';
import React from 'react';

export function RequestInfo(
  props: {
    label: string,
    text: string,
  }
) {
  return (
    <SimpleBlock>
      <SimpleBlock className={styles.label}>{props.label}</SimpleBlock>
      <SimpleBlock>
        <Right className={styles.copyButton}>
          <CopyValueToClipboard text={props.text} />
        </Right>
        <SimpleBlock className={styles.content}>
          {props.text}
        </SimpleBlock>
      </SimpleBlock>
    </SimpleBlock>
  );
}
